import { render, staticRenderFns } from "./live.vue?vue&type=template&id=a0356114&scoped=true"
import script from "./live.vue?vue&type=script&lang=js"
export * from "./live.vue?vue&type=script&lang=js"
import style0 from "./live.vue?vue&type=style&index=0&id=a0356114&prod&scoped=true&lang=css"
import style1 from "./live.vue?vue&type=style&index=1&id=a0356114&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0356114",
  null
  
)

export default component.exports